module.exports = __webpack_public_path__ + "img/icon-nature-title.611cfa92.png";